import { useI18nContext } from "@hopper-b2b/i18n";
import { PackageType } from "../../types";

export const usePackageSelectRadioGroup = () => {
  const { t } = useI18nContext();

  const packageTypeOptions = [
    {
      value: PackageType.HOTEL_FLIGHT_CAR,
      label: t("core-packages.packageType.hotelFlightCar"),
    },
    {
      value: PackageType.HOTEL_FLIGHT,
      label: t("core-packages.packageType.hotelFlight"),
    },
    {
      value: PackageType.HOTEL_CAR,
      label: t("core-packages.packageType.hotelCar"),
    },
    {
      value: PackageType.FLIGHT_CAR,
      label: t("core-packages.packageType.flightCar"),
    },
  ];

  return {
    context: {
      packageTypeOptions,
    },
  };
};
